/**
 * Keeps a Contentful section title inside the analytics API's event-name charset `[A-Za-z0-9_.#* -]`
 * by replacing any other character with `_`. Allowed characters pass through unchanged, so a title that
 * already fits (every one seen in prod analytics so far) keeps the event name reporting keys on.
 * Length is not capped: the API also limits names to 128 characters.
 */
export const toEventNameSegment = (title: string): string => title.replace(/[^A-Za-z0-9_.#* -]/g, "_");
